import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PortfCard from "./PortfCard";
import axios from "axios";
import { API_URL } from "../config";
import { useI18n } from "../i18n/I18nProvider";
import { SectionTitle } from "../i18n/SectionTitle";

function Portfolio() {
  const [projects, setProjects] = useState([]);
  const [visibleProjects, setVisibleProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useI18n();
  const itemsPerPage = 3;

  useEffect(() => {
    axios
      .get(`${API_URL}/api/works`)
      .then((response) => {
        setProjects(response.data);
        setVisibleProjects(response.data.slice(0, itemsPerPage));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching projects:", error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (loading || visibleProjects.length >= projects.length) return;

      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= documentHeight - 500) {
        setLoading(true);
        setTimeout(() => {
          const nextBatch = projects.slice(
            visibleProjects.length,
            visibleProjects.length + itemsPerPage
          );
          setVisibleProjects([...visibleProjects, ...nextBatch]);
          setLoading(false);
        }, 500);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [visibleProjects, projects, loading, itemsPerPage]);

  return (
    <div>
      <div className="portfolio_section layout_padding">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="portfolio-header">
                <Link to="/othersites" className="pro-btn pro-btn--primary home-services__cta portfolio-header__btn-top">
                  {t("portfolio.otherSites")}
                </Link>
                <div className="portfolio-header__content">
                  <SectionTitle
                    beforeKey="portfolio.title"
                    afterKey="portfolio.titleAccent"
                    className="portfolio_taital"
                  />
                  <p className="blog_text">{t("portfolio.subtitle")}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="portfolio_section_2">
            <div className="row portfolio-grid">
              {visibleProjects.length > 0 ? (
                visibleProjects.map((project) => (
                  <PortfCard key={project.id} project={project} />
                ))
              ) : (
                <p className="blog_text">{t("portfolio.loading")}</p>
              )}
              {loading && visibleProjects.length > 0 && (
                <div className="col-12 text-center py-4">
                  <p className="blog_text">{t("portfolio.loading")}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
